import { render } from "./RoleHasPermission.vue?vue&type=template&id=3aec81f7"
import script from "./RoleHasPermission.vue?vue&type=script&lang=js"
export * from "./RoleHasPermission.vue?vue&type=script&lang=js"
script.render = render

export default script